// Nav
export const enNavItem1 = "Home";
export const enNavItem2 = "About me";
export const enNavItem3 = "Projects";
export const enNavItem4 = "Contact";
export const enNavItem5 = "Language";
export const enNavItem6 = "English"
export const enNavItem7 = "Spanish"

// Home
export const hiThereUk = "Hi there, welcome to my webpage";
export const myProfileUk = "See my projects";

// Footer Contact
export const contactEn = "https://api.whatsapp.com/send?phone=+447864069428&text=Hello! I would like more information about your services as a Developer/Web Programmer.";

// Copyright
export const copyrightEn = `${new Date().getFullYear()} Cristian Herrera, Web Developer`

// Profile
export const h4En1 = "PERSONAL INFORMATION";
export const boldEn1 = "Fullname: ";
export const pEn1 = "Cristian Daniel Herrera";
export const boldEn6 = "Nationality: ";
export const pEn12 = "Argentine"
export const boldEn2 = "Email: ";
export const pEn2 = "cristian.daniel.herrera@hotmail.com";
export const boldEn3 = "Linkedin: "
export const pEn3 = "Click here"
export const boldEn4 = "GitHub: "
export const pEn4 = "Click here"

export const h4En2 = "PROFILE";
export const pEn5 = "After working as a professional musician for several years, I am now looking to start a new career as a Programmer and Web Developer. I am an enthusiastic person who is motivated and willing to learn new skills and work as part of a dedicated team. I have recently completed an introductory Programming course and am in the process of completing an Advanced Javascript course. I'm seeking a role where I can apply these newfound skills in a dynamic, practical way.";

export const h4En3 = "WORK EXPERIENCE"
export const pEn6 = "I was training at The Bit Cooperative Ltda for two years in Buenos Aires, Argentina. I learned how to use MERN stack to build an e-commerce web page. They offered me a position as a Junior, but unfortunately I couldn't accept because I was about to relocate to the UK.";
export const boldEn5 = "Letter of recommendation: "
export const pEn7 = "Click here"

export const h4En4 = "EDUCATION"
export const pEn8 = "Web Development for Beginners (Layout and Starter Javascript course). May 2020 - August 2020, UTN"
export const pEn9 = "Advanced Web Development (Stack MERN). August 2020 – December 2021, NucBA"
export const pEn10 = "Udemy (NodeJs). May 2021 - June 2021"
export const pEn11 = "IT Career (HTML, CSS, JavaScript, Testing, React, Nodejs, Postgresql, SQL, PHP, Python, C#, Java, Jquery. August 2021 - April 2022."

export const h4En5 = "LANGUAGES & FRAMEWORKS"

export const downloadCvEn = "Download my curriculum"

// Projects
export const projectEn = "Project"
export const descriptionEn = "Description"
export const tecnoligiesEn = "Tecnologies"
export const videoEn = "Video demostration"



